import { Input } from '@mentalgrowth/ui-kit-web';
import type { TpInputProps } from '@mentalgrowth/ui-kit-web';

import classNames from 'classnames';
import styles from './UiKitInput.module.css';

export const UiKitInput = (
  props: TpInputProps & {
    isError?: boolean;
  },
) => {
  const { className, isError, ...otherProps } = props;

  return (
    <Input
      className={classNames(className, {
        [styles.isError]: isError,
      })}
      {...otherProps}
    />
  );
};
